import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Tab,
  Tabs,
} from '@material-ui/core';
import { IonRow } from '@ionic/react';
import { SPORTS_ICONS } from '../../constants/SportsNavView';
import ExchangeSportsIconList from '../../components/ExchSportsListNav/ExchangeSportsIconList';
import {
  getExchangeEvents,
  fetchEventsByCompetition,
  setExchEvent,
  setCompetition,
  fetchEventsBySport,
} from '../../store';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { RootState } from '../../models/RootState';
import { EventDTO } from '../../models/common/EventDTO';
import {
  unsubscribeAllWsforEvents,
  subscribeWsForEventOdds,
  isConnected,
  disconnectToWS,
} from '../../webSocket/webSocket';
import { formatDate, formatTime } from '../../util/stringUtil';
import moment from 'moment';
import './ExchRaceTable.scss';
// import './ExchEventsTable.scss';

type StoreProps = {
  events: EventDTO[];
  selectedEventType: SelectedObj;
  selectedCompetition: SelectedObj;
  fetchEventsByCompetition: (
    sportId: string,
    competitionId: string,
    events: EventDTO[]
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  setCompetition: (competition: SelectedObj) => void;
  fetchEventsBySport: (sportId: string, events: EventDTO[]) => void;
  fetchingEvents: boolean;
  loggedIn: boolean;
  topicUrls: any;
  betFairWSConnected: boolean;
};

const EventsTable: React.FC<StoreProps> = (props) => {
  const {
    events,
    selectedEventType,
    selectedCompetition,
    fetchEventsByCompetition,
    setExchEvent,
    setCompetition,
    fetchEventsBySport,
    fetchingEvents,
    loggedIn,
    topicUrls,
    betFairWSConnected
  } = props;

  const pathParams = useParams();
  const [wsChannels, setWsChannels] = useState<string[]>([]);
  const [tabVal, setTabVal] = useState(1);
  const [eventData, setEventData] = useState<EventDTO[]>([]);
  const [compitationsList, setCompitationsList] = useState<{}>({});
  const [value, setValue] = React.useState('');
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const tableFields = [
    {
      key: 'teams',
      Label: 'Races',
      className: 'teams-cell race-name-cell-head',
      align: 'left',
    },
    {
      key: 'markets',
      Label: '',
      className: 'odds-cell-head tab-view',
      align: 'left',
      colSpan: 1,
    },
  ];

  useEffect(() => {
    if (!pathParams['competition']) {
      setCompetition({ id: '', name: '', slug: '' });
    }
  }, [pathParams]);

  const updateEvents = () => {
    if (!pathParams['competition']) {
      if (
        selectedEventType.id &&
        events &&
        selectedEventType.id === events[0]?.sportId
      )
        fetchEventsBySport(selectedEventType.id, events);
    } else {
      if (
        selectedEventType.id &&
        events &&
        selectedEventType.id === events[0]?.sportId
      ) {
        fetchEventsByCompetition(
          selectedEventType.id,
          selectedCompetition.id,
          events
        );
      }
    }
  };

  const updateMatchOddsTopic = (currentTopic: string, currentBaseUrl: string) => {
    if (matchOddsTopic !== currentTopic || matchOddsBaseUrl !== currentBaseUrl) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  }
  
  const setCompitations = (events: EventDTO[]) => {
    let compitations: { [key: number]: EventDTO[] } = {};
    const unique = [
      ...new Set(events.map((item) => item?.competitionId?.split('_')[0])),
    ];
    for (let key of unique) {
      compitations[key] =
        events?.filter((item) => item?.competitionId?.startsWith(key + '_')) ??
        [];
    }
    const sorted = Object.keys(compitations)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = compitations[key];
        return accumulator;
      }, {});

    setCompitationsList(sorted);
    value === '' && setValue(unique[0]);
  };
  useEffect(() => {
    if (!pathParams['competition']) {
      fetchEventsBySport(selectedEventType.id, events);
    }
  }, [selectedEventType]);

  useEffect(() => {
    if (pathParams['competition'] && !events) {
      fetchEventsByCompetition(
        selectedEventType.id,
        selectedCompetition.id,
        events
      );
    }
  }, [selectedCompetition]);

  useEffect(() => {
    updateEvents();
  }, [loggedIn]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      updateEvents();
    }, 10000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [selectedEventType]);

  // Unsubscribe Web socket messages
  useEffect(() => {
    unsubscribeAllWsforEvents();
    setWsChannels([]);
  }, [selectedEventType]);

  useEffect(() => {
    if (pathParams['competition']) {
      unsubscribeAllWsforEvents();
      setWsChannels([]);
    }
  }, [selectedCompetition, pathParams]);

  useEffect(() => {
    if (loggedIn) {
      if (selectedEventType.id === '4' && events && topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(topicUrls?.matchOddsTopic, topicUrls?.matchOddsBaseUrl);
        let subs = [...wsChannels];
        for (let event of events) {
          if (event.matchOdds.status === 'IN_PLAY' && !wsChannels.includes(event.eventId)) {
            subs.push(event.eventId);
            subscribeWsForEventOdds(
              topicUrls?.matchOddsTopic,
              event.sportId,
              event.competitionId,
              event.eventId,
              event.matchOdds?.marketId,
              event.providerName
            );
          }
        }
        setWsChannels(subs);
      }
    }
  }, [betFairWSConnected, events, selectedEventType, loggedIn]);

  useEffect(() => {
    if (events) {
      setEventData([...events]);
      setCompitations(events);
    }
  }, [events]);

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  const handleEventChange = (event: EventDTO) => {
    setCompetition({
      id: event.competitionId,
      name: event.competitionName,
      slug: getCompetitionSlug(event.competitionName),
    });
    setExchEvent({
      id: event.eventId,
      name: event.eventName,
      slug: event.eventSlug,
    });
  };
  const handleEventData = (data) => {
    return data.sort((a, b) => {
      if (a.status === 'IN_PLAY' && b.status !== 'IN_PLAY') return -1;
      if (a.status !== 'IN_PLAY' && b.status === 'IN_PLAY') return 1;
    });
  };

  const isLive = (date: Date) => {
    let duration = moment.duration(moment(date).diff(moment()));
    return duration?.asMinutes() < 10 ? true : false;
  };
  return (
    <div className="events-table-ctn">
      <div className="events-section">
        <div className="card">
          <div className="carw">
            <div className="arrow arrow-right">
              <div className="img-ctn">
                <img
                  className={'sport-icon'}
                  alt={selectedEventType?.name}
                  src={
                    SPORTS_ICONS[selectedEventType?.name]
                      ? SPORTS_ICONS[selectedEventType?.name]
                      : SPORTS_ICONS['Other']
                  }
                />
              </div>
              {selectedEventType?.name}
            </div>
          </div>
          <div className="nav-list-event-table">
            <ExchangeSportsIconList />
          </div>
          {eventData ? (
            eventData.length > 0 ? (
              <>
                <div className="events-table-content table-ctn mt-6">
                  <TableContainer component={Paper} className="border-radius">
                    <Table className="events-table inplay-table">
                      <TableHead>
                        <TableRow>
                          {tableFields.map((tF, index) => (
                            <TableCell
                              key={tF.key + index}
                              align={tF.align === 'left' ? 'left' : 'center'}
                              colSpan={tF.colSpan ? tF.colSpan : 1}
                              className={tF.className}
                            >
                              {tF.Label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className="tab-row">
                          <TableCell colSpan={8}>
                            <Tabs
                              value={value}
                              onChange={handleChange}
                              aria-label="basic tabs example"
                              className="exch-sports-list"
                            >
                              {Object?.keys(compitationsList)?.map(
                                (key, idx) => (
                                  <Tab
                                    className="tab"
                                    label={key}
                                    value={key}
                                  />
                                )
                              )}
                            </Tabs>
                          </TableCell>
                        </TableRow>
                        {compitationsList[value]?.length > 0 ? (
                          handleEventData(compitationsList[value])?.map(
                            (sEvent, idx) => (
                              <>
                                {sEvent.sportId === selectedEventType.id &&
                                sEvent.raceMarkets?.length > 0 ? (
                                  <TableRow key={idx}>
                                    <TableCell className="teams-cell">
                                      <div className="team-name">
                                        {sEvent.eventName}
                                      </div>
                                      <div className="lap-view race-market-times">
                                      {sEvent.raceMarkets?.map((mr, idx) => (
                                    <>
                                      {idx < 5 ? (
                                        <NavLink
                                          className="all-markets-nav-link"
                                          key={'all-markets-link'}
                                          onClick={() =>
                                            handleEventChange(sEvent)
                                          }
                                          to={`/exchange_sports/${
                                            selectedEventType.slug
                                          }/${getCompetitionSlug(
                                            sEvent.competitionName
                                          )}/${sEvent.eventSlug}/${btoa(
                                            `${sEvent.sportId}:${sEvent.competitionId}:${sEvent.eventId}:${mr.marketTime}`
                                          )}`}
                                          id={mr.marketId}
                                        >
                                          <div
                                            className={
                                              isLive(mr.marketTime)
                                                ? 'market-time live'
                                                : 'market-time'
                                            }
                                          >
                                            {formatTime(mr.marketTime)}
                                          </div>
                                        </NavLink>
                                      ) : null}
                                    </>
                                  ))}
                                      </div>
                                    </TableCell>
                                    <TableCell
                                      className="odds-cell tab-view race-markets"
                                      align="left"
                                      colSpan={2}
                                      key="market-time-cell"
                                    >
                                      <div className="race-market-times">
                                        {sEvent.raceMarkets?.map((mr,i) => (
                                           <>
                                           {i < 5 ? (
                                          <NavLink
                                            className="all-markets-nav-link"
                                            key={'all-markets-link'}
                                            onClick={() =>
                                              handleEventChange(sEvent)
                                            }
                                            to={`/exchange_sports/${
                                              selectedEventType.slug
                                            }/${getCompetitionSlug(
                                              sEvent.competitionName
                                            )}/${sEvent.eventSlug}/${btoa(
                                              `${sEvent.sportId}:${sEvent.competitionId}:${sEvent.eventId}:${mr.marketTime}`
                                            )}`}
                                          >
                                            <div
                                              className={
                                                isLive(mr.marketTime)
                                                  ? 'market-time live'
                                                  : 'market-time'
                                              }
                                            >
                                              {formatTime(mr.marketTime)}
                                            </div>
                                          </NavLink>
                                          ) : null}
                                          </>
                                        ))}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ) : null}
                              </>
                            )
                          )
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={8}>
                              There is no inplay matches.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>
            ) : !fetchingEvents ? (
              <div className="events-table-msg-text">No Events to display</div>
            ) : null
          ) : null}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  return {
    events: getExchangeEvents(
      state.exchangeSports.events,
      eventType.id,
      competition.id
    ),
    selectedEventType: eventType,
    selectedCompetition: competition,
    fetchingEvents: state.exchangeSports.fetchingEvents,
    topicUrls: state?.exchangeSports?.topicUrls,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchEventsByCompetition: (
      sportId: string,
      competitionId: string,
      events: EventDTO[]
    ) => dispatch(fetchEventsByCompetition(sportId, competitionId, events)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    fetchEventsBySport: (sportId: string, events: EventDTO[]) =>
      dispatch(fetchEventsBySport(sportId, events)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsTable);
